export const AVAILABLE = 0;
export const MIGHT_BE_NOT_AVAILABLE = 1;
export const NOT_AVAILABLE = 2;
export const NOT_AVAILABLE_INTERNAL = 3;
export const NOT_FIND = 9;
export const SEARCH_ERROR = 99;
